import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import { useNavigate } from "react-router-dom";
import * as yup from 'yup';
import { ArrowLeft, ArrowRight, ListCheck, Printer, Save } from 'react-bootstrap-icons';
import AlertControl from './Controls/AlertControl';
import { CallAPI, IsError } from '../global/APIUtils';
import OverlaySpinner from './Controls/OverlaySpinner';
import { Grid, Box, Typography, FormControl, TextField, Button, Paper } from '@mui/material';
import { ErrorMessages } from '../common/ErrorMessages';
import { APICall } from '../global/Api';

const ProfileChangePassword = (props) => {

    //const sessions = useSelector((state) => state.sessionMgmnt);
    //const dispatch = useDispatch();
    const [submit, setSubmit] = useState(false);
    const [regMsg, setRegMsg] = useState('');
    const [validationMsg, setValidationMsg] = useState('');
    const [msgModalShow, setMsgModalShow] = useState(false);
    const [alertSucStatus, setAlertSucStatus] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [infoMsg, setInfoMsg] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [lastPwdChangeDate, setLastPwdChangeDate] = useState('');

    const [userId, setUserId] = useState(props.userId || -1);
    const [sessionId, setSessionId] = useState(props.sessionId || '');

    const pwdRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
    let history = useNavigate();

    const existHandeler = () => {
        history.push({ pathname: '/DashBoard' });
    }

    const GetLastPwdChangeDate = async () => {
        //let baseUrl = process.env.REACT_APP_BASE_URL;

        const apiUrl = new URL(
            process.env.REACT_APP_GET_PASSWORD_CHANGEDATE,
            process.env.REACT_APP_BASE_URL,
        );

        apiUrl.searchParams.set('ID', `${userId}`);

        try {

            setIsLoading(true);

            //let response = await CallAPI({ url: apiUrl.href, method: 'GET', headers: {} }, userId, sessionId);
            let response = await APICall({ url: apiUrl.href, method: 'GET', contentType: 'application/json', responseType: '' }, userId, sessionId);

            if (response !== undefined && response !== null) {
                setIsLoading(false);
                if (response.data && response.data.length > 0) {
                    setLastPwdChangeDate('Last changed ' + response.data[0].PasswordChangeDate);
                }
            }
        }
        catch (err) {
            setErrorMsg(ErrorMessages.UnknownError);
            setIsLoading(false);
        }
        finally {
            
        }
    }

    useEffect(() => {

        GetLastPwdChangeDate();
    }, []);

    const changePwdForm = useFormik({
        //enableReinitialize: true,
        initialValues: {
            CurrentPassword: "",
            NewPassword: "",
            ConfirmPassword: ""
        },

        validationSchema: yup.object({
            CurrentPassword: yup.string()
                .required('Current Password - required.'),
            NewPassword: yup.string()
                .max(20, "New Password - must be a string with a minimum length of '10' and a maximum length of '20'.")
                .min(10, "New Password - must be a string with a minimum length of '10' and a maximum length of '20'.")
                //.matches(pwdRegExp,
                //    "New Password - must be contain '10' characters, one uppercase, one lowercase, one number and one special case character."
                //)
                .required('Password - required.'),
            ConfirmPassword: yup.string()
                .max(20, "Confirm Password - must be a string with a minimum length of '10' and a maximum length of '20'.")
                .min(10, "Confirm Password - must be a string with a minimum length of '10' and a maximum length of '20'.")
                //.matches(pwdRegExp,
                //    "Confirm Password - must be contain '10' characters, one uppercase, one lowercase, one number and one special case character."
                //)
                //.when("NewPassword", {
                //    is: psswrd => (psswrd && psswrd.length > 0 ? true : false),
                //    then: yup.string().oneOf(
                //        [yup.ref("NewPassword")],
                //        "Both password need to be the same.")
                //})
                .required('Confirm Password - required.')
        }),
        onSubmit: values => {
            submitClick(values);
        },
    });

    const submitClick = async (values) => {

        setSubmit(true); 
        setValidationMsg('');

        let chngModel = {
            EmailAddress: props.emailadrs,
            Password: values.CurrentPassword,
            NPassword: values.NewPassword,
            CPassword: values.ConfirmPassword,
            UserId: parseInt(userId)
        };

        let headers = {
            'Content-Type': 'application/json'
        };

        const apiUrl = new URL(
            process.env.REACT_APP_CHANGE_PASSWORD,
            process.env.REACT_APP_BASE_URL,
        );

        try {

            setIsLoading(true);

            //let response = await CallAPI({ url: apiUrl.href, method: 'POST', headers: headers, body: chngModel }, userId, sessionId);
            let response = await APICall({ url: apiUrl.href, method: 'POST', payload: chngModel, contentType: 'application/json', responseType: '' }, userId, sessionId);

            if (response != null && response != undefined) {

                setIsLoading(false);

                let error = IsError(response);

                if (error != 0) {
                    setErrorMsg(response.Errors[0].Message);
                }
                else {
                    changePwdForm.resetForm();
                    setSuccessMsg("Your new password is now active!");
                }
            }
        }
        catch (err) {
            setErrorMsg(ErrorMessages.UnknownError);
            setIsLoading(false);
        }
        finally {
        }
    }

    return (
        <React.Fragment>
            <OverlaySpinner disappear={isLoading} />
            <Grid item xs container direction="row" sx={{ borderLeft: 1, borderColor: 'divider', ml: 0, mt: 0 }}>
                <Grid item xs={10} sx={{ mb: 2, }}>
                    <Typography gutterBottom variant="h5" color="text.secondary" sx={{ ml: 7, mr: 5, lineHeight: 2.5, fontWeight: 500, borderBottom: '1px solid rgba(0,0,0,0.1)'}}>
                        Change password
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ ml: 7, mr: 5, }}>
                        {lastPwdChangeDate}
                    </Typography>
                </Grid>
                {/*<Grid item xs={10} sx={{ mt: 0, }}>*/}
                {/*    <Box className="text-center" style={{ cursor: 'pointer', }}>*/}
                {/*        <span className="">*/}
                {/*            <svg viewBox="0 0 500 500" width="96" height="96"><g id="Layer_10" ><circle cx="162.31" cy="365.52" r="28.45" fill="#3fe2fd"></circle><path d="M208.56,174.18s4.28,132.9,26.09,151.76a235.52,235.52,0,0,1,20.74,20.18,31.69,31.69,0,0,1,7.51,27.71l-4.5,21.48H220.87l14.59-73.46-72.65-35.33L168,175.87l11.49-8.94Z" fill="#3fe2fd"></path><path d="M312,265.24a25.73,25.73,0,1,0-42,19.88,11.2,11.2,0,0,0-.08,1.3v38.66a12,12,0,0,0,12,12h10.22a12,12,0,0,0,12-12V286.42a11.92,11.92,0,0,0-.25-2.4A25.63,25.63,0,0,0,312,265.24Z" fill="#3fe2fd"></path></g><g id="Layer_3" data-name="Layer 3"><path d="M385.3,409.31H218.63a7,7,0,0,1,0-14H385.3A18.3,18.3,0,0,0,403.58,377V192.45a18.3,18.3,0,0,0-18.28-18.27H189.13a18.29,18.29,0,0,0-18.27,18.27v99.8a7,7,0,0,1-14,0v-99.8a32.3,32.3,0,0,1,32.27-32.27H385.3a32.31,32.31,0,0,1,32.28,32.27V377A32.32,32.32,0,0,1,385.3,409.31Z" fill="#251ac7"></path><path d="M359,174.18a7,7,0,0,1-7-7V119.06a68.21,68.21,0,0,0-136.41,0v48.12a7,7,0,0,1-14,0V119.06a82.21,82.21,0,0,1,164.41,0v48.12A7,7,0,0,1,359,174.18Z" fill="#251ac7"></path><path d="M162.81,463.16a16.46,16.46,0,0,1-8.66-2.47l-5-3a132.54,132.54,0,0,1-61.64-92.53L82.62,333.7a16.6,16.6,0,0,1,9.44-17.6l63.84-29.34h0a16.52,16.52,0,0,1,13.82,0l63.85,29.34A16.58,16.58,0,0,1,243,333.7l-4.92,31.42a132.57,132.57,0,0,1-61.64,92.53l-5,3.05A16.57,16.57,0,0,1,162.81,463.16Zm0-163.91a2.47,2.47,0,0,0-1.06.23h0L97.91,328.82a2.54,2.54,0,0,0-1.46,2.71L101.38,363a118.54,118.54,0,0,0,55.14,82.77l5,3a2.56,2.56,0,0,0,2.67,0l5-3A118.58,118.58,0,0,0,224.25,363l4.92-31.42a2.55,2.55,0,0,0-1.45-2.71l-63.84-29.34A2.52,2.52,0,0,0,162.81,299.25Zm-4-6.13h0Z" fill="#251ac7"></path><path d="M300.78,345.48H273.1a7,7,0,0,1-7-7V290.4a34.83,34.83,0,1,1,41.68-.24v48.32A7,7,0,0,1,300.78,345.48Zm-20.68-14h13.68V286.43a7,7,0,0,1,3.47-6,20.83,20.83,0,1,0-20.7.13,7,7,0,0,1,3.55,6.09Z" fill="#251ac7"></path><path d="M158.23,390.15h-.16a7,7,0,0,1-5.41-2.75L135.3,364.58a7,7,0,0,1,11.14-8.48l12,15.82L178.38,348a7,7,0,1,1,10.76,9l-25.53,30.64A7,7,0,0,1,158.23,390.15Z" fill="#251ac7"></path></g>*/}
                {/*            </svg>*/}
                {/*        </span>*/}
                {/*    </Box>*/}
                {/*</Grid>*/}
                <Grid item xs={9} container direction="row" sx={{ ml: 7, mr: 4, mt: 2 }}>
                    <form className="w-100" onSubmit={changePwdForm.handleSubmit} id="frmChangePwd">
                        <Grid item xs={10} sx={{ }} >
                            <AlertControl Message={errorMsg} severity="error" color="error" icon={true} />
                            <AlertControl Message={successMsg} severity="success" color="success" icon={true} />
                            <Typography variant="body1" color="text.secondary" sx={{mb: 4, fontWeight: 500 }}>
                                Don't use a variation of an old password or any personal information.
                            </Typography>
                            <Paper elevation={0} sx={{width: '80%'}}>
                                <label htmlFor="CurrentPassword" className="form-label">Current Password*</label>
                                <input type="password" autoComplete="off" id="CurrentPassword" name="CurrentPassword" placeholder="Enter current password here" className="form-control" value={changePwdForm.values.CurrentPassword} onChange={changePwdForm.handleChange} />
                                    {
                                        changePwdForm.touched.CurrentPassword && changePwdForm.errors.CurrentPassword ? (<p className="text-danger">{changePwdForm.errors.CurrentPassword}</p>) : null
                                    }
                            </Paper>
                            </Grid>
                        <Grid item xs={10} sx={{ pt: 2 }} >
                            <Paper elevation={0} sx={{ width: '80%' }}>
                                <label htmlFor="NewPassword" className="form-label">New Password*</label>
                                <input type="password" autoComplete="off" id="NewPassword" name="NewPassword" placeholder="Enter new password here" className="form-control" value={changePwdForm.values.NewPassword} onChange={changePwdForm.handleChange} />
                                {
                                    changePwdForm.touched.NewPassword && changePwdForm.errors.NewPassword ? (<p className="text-danger">{changePwdForm.errors.NewPassword}</p>) : null
                                }
                            </Paper>
                        </Grid>
                        <Grid item xs={10} sx={{ pt: 2 }} >
                            <Paper elevation={0} sx={{ width: '80%' }}>
                                <label htmlFor="ConfirmPassword" className="form-label">Confirm Password*</label>
                                <input type="password" autoComplete="off" id="ConfirmPassword" name="ConfirmPassword" placeholder="Re-enter new password here" className="form-control" value={changePwdForm.values.ConfirmPassword} onChange={changePwdForm.handleChange} />
                                {
                                    changePwdForm.touched.ConfirmPassword && changePwdForm.errors.ConfirmPassword ? (<p className="text-danger">{changePwdForm.errors.ConfirmPassword}</p>) : null
                                }
                            </Paper>
                        </Grid>
                        <Grid item sm={12} sx={{}} >
                            <Box sx={{ pt: 4 }}>
                                <FormControl variant="outlined" sx={{}}>
                                    <Button type="submit" variant="outlined" size="large" style={{ boxShadow: 'none', border: '2px solid #0972d3', borderRadius: '40px', padding: '0.4rem 2.5rem', textTransform: 'none', }}>
                                        <Typography variant="body2" color="#0972d3" sx={{ fontWeight: 600 }} >Save</Typography>
                                    </Button>

                                    {/*<Button type="submit" variant="outlined" size="small" sx={{ padding: '0.4rem 3rem', border: 2, borderColor: '#616161' }}>*/}
                                    {/*    <Typography variant="body2" color="#212121" sx={{ textTransform: 'none', fontWeight: 500 }} >Save</Typography>*/}
                                    {/*</Button>*/}
                                </FormControl>
                            </Box>
                        </Grid>
                    </form>
                </Grid>
            </Grid>
        </React.Fragment>
    );

}
export default ProfileChangePassword;